import { Typography } from '@mui/material'
import { useGetProjectModel } from '@/service-library/hooks/project-models'
import { WorkflowStateAction } from '@/types/workflow-state-actions'
import PrimaryTextWrapper from './PrimaryTextWrapper'

type RunPredictionModelDisplayProps = {
  action: WorkflowStateAction
}

export default function RunPredictionModelDisplay({
  action,
}: RunPredictionModelDisplayProps) {
  const { projectModel, isPending } = useGetProjectModel({
    id: action.params.model_id,
    filters: {
      fields__only: 'id,name',
    },
  })

  if (isPending) return null

  return (
    <Typography variant="body2" color="text.secondary">
      Run the <PrimaryTextWrapper>{projectModel?.name}</PrimaryTextWrapper>{' '}
      prediction model.
      {action.params.flag_if_no_model_version
        ? " If there isn't a model version available, the document will be flagged with an info flag."
        : ''}
    </Typography>
  )
}
